import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import { Loading } from "element-ui";
import { fetchLanguage } from "@/api/language";

import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui 自带 英语
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui 自带 中文
import elementEsLocale from "./es_ES"; // 自定义element-ui 西班牙语
import elementEs_esLocale from "element-ui/lib/locale/lang/es"; // 自定义element-ui 西班牙语

import enLocale from "./en";
import zhLocale from "./zh-CN";

Vue.use(VueI18n);

const messages = {
  en_GB: {
    ...enLocale,
    ...elementEnLocale,
  },
  zh_CN: {
    ...zhLocale,
    ...elementZhLocale,
  },
  es_MX: {
    ...enLocale,
    ...elementEsLocale,
    ...elementEs_esLocale,
  },
  es_CO: {
    ...enLocale,
    ...elementEsLocale,
    ...elementEs_esLocale,
  },
};

export function getLanguage() {
  const lang = localeLanguage();
  const loading = Loading.service({
    lock: true,
  });
  // console.log(lang, 'lang')
  fetchLanguage({ langCode: lang })
    .then((response) => {
      // console.log(response, 'fetchLanguage')
      const constMessages = messages[lang] || {};
      const asyncMessages = response.data || {};
      i18n.setLocaleMessage(lang, { ...constMessages, ...asyncMessages });
      loading.close();
    })
    .catch(() => {
      loading.close();
    });
  return lang;
}

export function localeLanguage() {
  const chooseLanguage = Cookies.get("language");
  // console.log(chooseLanguage,'chooseLanguage')
  if (chooseLanguage) {
    // console.log(chooseLanguage, 'chooseLanguage')
    return chooseLanguage;
  }

  let language = navigator.language || navigator.browserLanguage;
  console.log(language, "============浏览器默认language=============");
  if (language.indexOf("zh") > -1) {
    language = "zh_CN";
  } else if (language.indexOf("en") > -1) {
    language = "en_GB";
  } else if (language.indexOf("de") > -1) {
    language = "de_DE";
  } else if (language.indexOf("es") > -1) {
    language = "es_MX";
  }
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return "en";
}

const i18n = new VueI18n({
  locale: localeLanguage(),
  messages,
  silentTranslationWarn: true,
  fallbackLocale: "en_GB",
});

export default i18n;
